<script>
  import { getDateText } from '../../../common/dates';
  export let item;

  let content;
  $: item && filterItem();

  const filterItem = () => {
    const group = item.groups;
    content = group.find((item) => item.id === 'main');
  };
</script>

<style src="feeditem.scss">
</style>

{#if content && content.refs}
  <article class="feed-item" data-post-id={item._id}>
    <div class="title">
      <span class="red-text">{getDateText(item.published_date)}</span>
      <span class="byline">{item.byline || ''}</span>
    </div>
    <div class="content">
      {#each content.refs as post}
        {@html post.item && post.item.text}
        {#if item._current_version > 1 && !item.lb_highlight}
          <div class="updated">Oppdatert {getDateText(item._updated)}</div>
        {/if}
      {/each}
    </div>
  </article>
{/if}
